<template>
  <div class="monitor-code">
    <div class="monitor-code__bar">
      <span class="monitor-code__lang">{{label || lang}}</span>
      <b-button variant="link" size="sm" class="monitor-code__copy" @click="copy" v-b-tooltip.hover title="Copiar">
        <AppIcon :name="copied ? 'check' : 'content_copy'" />
      </b-button>
    </div>
    <pre class="monitor-code__pre" :class="'language-' + lang"><code :class="'language-' + lang" v-html="highlighted"></code></pre>
  </div>
</template>

<script>
  import Prism from 'prismjs'
  import 'prismjs/components/prism-json'
  import 'prismjs/components/prism-bash'
  import 'prismjs/themes/prism.css'

  export default {
    props: {
      code: { type: String, default: '' },
      lang: { type: String, default: 'json' },
      label: { type: String, default: '' },
    },
    data: () => {
      return {
        copied: false,
      }
    },
    computed: {
      highlighted() {
        var grammar = Prism.languages[this.lang]
        if(!grammar) return this.escape(this.code)
        return Prism.highlight(this.code || '', grammar, this.lang)
      },
    },
    methods: {
      escape(text) {
        return String(text || '').replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c])
      },
      copy() {
        var done = () => {
          this.copied = true
          setTimeout(() => { this.copied = false }, 1500)
        }
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(this.code).then(done).catch(() => this.copyFallback(done))
          return
        }
        this.copyFallback(done)
      },
      copyFallback(done) {
        var textarea = document.createElement('textarea')
        textarea.value = this.code
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        var copied = document.execCommand('copy')
        textarea.remove()
        copied ? done() : this.$awn.alert('No se pudo copiar')
      },
    }
  }
</script>

<style scoped>
  .monitor-code {
    border: 1px solid #e3e6ea;
    border-radius: 6px;
    background: #f8f9fb;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .monitor-code__bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 6px 2px 10px;
    border-bottom: 1px solid #e3e6ea;
    background: #eef1f4;
  }

  .monitor-code__lang {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .04em;
    color: #6c757d;
    font-weight: 600;
  }

  .monitor-code__copy {
    padding: 0 4px;
    color: #495057;
  }

  .monitor-code__pre {
    margin: 0 !important;
    padding: 10px 12px !important;
    max-height: 420px;
    overflow: auto;
    background: transparent !important;
    font-size: 12px;
    line-height: 1.5;
  }
</style>
